module.exports = __webpack_public_path__ + "img/shahnawaz-smc.ce7d8882.jpg";